import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PlayerFeatures } from 'src/hooks/useInitModuleFeatures';
import { initialPlayerParamsState } from 'src/playerParams/utils';
import { PlayerParamsState } from 'src/types/playerParams.type';
import { RECORD_POLL_DISABLE_HOT_KEYS } from 'src/types/poll.types';

interface FeatureControlState {
  disableHotKeyEvents: Record<string, boolean>; // Maps feature names to their disable state
  playerParams: PlayerParamsState;
  isFullScreen: boolean;
  playerFeatures: PlayerFeatures;
}

const initialState: FeatureControlState = {
  disableHotKeyEvents: {},
  playerParams: initialPlayerParamsState,
  isFullScreen: false,
  playerFeatures: {
    isKhazanaVideo: false,
    isCommentsFeatureEnabled: false,
    isAttachmentFeatureEnabled: false,
    isChatFeatureEnabled: false,
    isNotesFeatureEnabled: false,
    isPollFeatureEnabled: false,
    isTopicTimestampFeatureEnabled: false,
    isBatchDoubtFeatureEnabled: false,
    isTimelineFeatureEnabled: false,
    isNoteMakingFeatureEnabled: false,
    isRatingFeatureEnabled: false,
    isReportFeatureEnabled: false,
  },
};

export const featureControlSlice = createSlice({
  name: 'featureControl',
  initialState,
  reducers: {
    setRecordPollHotKeyEvent: (state, action: PayloadAction<{ isEnable: boolean }>) => {
      const { isEnable } = action.payload;
      state.disableHotKeyEvents = isEnable ? RECORD_POLL_DISABLE_HOT_KEYS : {};
    },
    setPlayerParams(state, action: PayloadAction<Partial<PlayerParamsState>>) {
      Object.assign(state.playerParams, action.payload);
    },
    updateIsFullScreen(state, action: PayloadAction<boolean>) {
      state.isFullScreen = action.payload;
    },
    updatePlayerFeatures(state, action: PayloadAction<PlayerFeatures>) {
      state.playerFeatures = {
        ...state.playerFeatures,
        ...action.payload,
      };
    },
  },
});

export const {
  setRecordPollHotKeyEvent,
  setPlayerParams,
  updateIsFullScreen,
  updatePlayerFeatures,
} = featureControlSlice.actions;

export default featureControlSlice.reducer;
